import SearchIcon from '@mui/icons-material/Search';
import Slider from '@mui/material/Slider';
import {styled} from '@mui/material/styles';
import classes from './Search.module.css';
import SearchField from './SearchField/SearchField';
import {useState} from 'react';

const Search = ({backgroundColor, 
                 iStyles, 
                 iHeight, 
                 iWidth, 
                 searchFieldStyles,
             }) => {
    const Icon = styled(SearchIcon)(({theme}) => ({...iStyles}));

    const [fieldPosition, setFieldPosition] = useState('translate(0)');
    const [fieldWidth, setFieldWidth] = useState(iWidth);

    const moveField = (amount) => {
        setFieldPosition(`translate(${amount}px)`);
    }

    const changeFieldWidth = (amount) => {
        setFieldWidth(`${amount}`)
    }

    return (
        <div onMouseLeave={() => {
                moveField('0');
                changeFieldWidth(iWidth);
            }} className={classes.container}>
            <div className={classes.coverLayer} style={{
                height:iHeight, 
                width:iWidth,
                backgroundColor: backgroundColor
            }}/>
            <Icon onMouseOver={() => {
                moveField('-50');
                changeFieldWidth('100px');
            }}/>
            <SearchField placeholder={'Search'} styles={{
                zIndex:'1',
                position: 'absolute',
                transform: fieldPosition,
                width: fieldWidth,
                opacity: fieldWidth==='100px'?'1':'0',
            }} cssClass={searchFieldStyles}/>
        </div>
    );
};

export default Search;